document.addEventListener('turbolinks:load', () => {
  document.querySelectorAll('[data-quicksearch-input]').forEach((input) => {
    const clear = input.closest('.quicksearch__container').querySelector('[data-quicksearch-clear]')
    const search = input.closest('.quicksearch__container').querySelector('[data-quicksearch-search]')
    if (!clear && !search) return

    const toggleClear = () => {
      const hasValue = input.value.length > 0

      if (clear) {
        clear.style.display = hasValue ? '' : 'none'
      }

      if (search) {
        search.style.display = hasValue ? 'none' : ''
      }
    }

    input.addEventListener('input', toggleClear)

    if (clear) {
      clear.addEventListener('click', () => {
        input.value = ''
        clear.style.display = 'none'
        input.focus()
        if (search) search.style.display = ''
      })
    }

    if (search) {
      search.addEventListener('click', () => input.focus())
    }

    toggleClear()
  })
})
